import { Routes, Route } from 'react-router-dom';
import DocsHome from './pages/DocsHome';
import DocPage from './pages/DocPage';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Routes>
      <Route path="/" element={<DocsHome />} />
      <Route path="/:slug" element={<DocPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
